import React from 'react';
import { Link } from 'react-router-dom';
import { RotateCcw, Clock, CheckCircle, AlertCircle, XCircle, Wrench } from 'lucide-react';

export const ReturnsPolicy = () => {
  return (
    <div className="min-h-screen py-16 bg-[#F9F8F6]" data-testid="returns-policy-page">
      <div className="container-custom max-w-4xl">
        <div className="mb-12">
          <h1 className="text-4xl md:text-5xl font-heading font-bold mb-4" data-testid="returns-title">Returns & Refunds Policy</h1>
          <p className="text-lg text-softgrey">We want you to be fully satisfied with your purchase.</p>
        </div>

        <div className="space-y-10">
          <section className="bg-cream p-8 rounded-xl" data-testid="cooling-off-section">
            <div className="flex items-center gap-3 mb-4">
              <Clock className="w-6 h-6 text-coral" />
              <h2 className="text-2xl font-heading font-bold">Cooling-Off Period</h2>
            </div>
            <p className="text-softgrey leading-relaxed">You have <strong>14 days</strong> to cancel your order.</p>
          </section>

          <section data-testid="return-window-section">
            <div className="flex items-center gap-3 mb-4">
              <RotateCcw className="w-6 h-6 text-coral" />
              <h2 className="text-2xl font-heading font-bold">Return Window</h2>
            </div>
            <p className="text-softgrey leading-relaxed">You have an additional <strong>14 days</strong> to return items.</p>
          </section>

          <section data-testid="conditions-section">
            <div className="flex items-center gap-3 mb-4">
              <CheckCircle className="w-6 h-6 text-coral" />
              <h2 className="text-2xl font-heading font-bold">Conditions</h2>
            </div>
            <ul className="list-disc list-inside space-y-2 text-softgrey ml-2">
              <li>Items must be unworn</li>
              <li>Returned in original condition</li>
            </ul>
          </section>

          <section data-testid="refunds-section">
            <h2 className="text-2xl font-heading font-bold mb-4">Refunds</h2>
            <ul className="list-disc list-inside space-y-2 text-softgrey ml-2">
              <li>Processed within <strong>14 days</strong></li>
              <li>Includes standard delivery</li>
            </ul>
          </section>

          <section data-testid="return-costs-section">
            <h2 className="text-2xl font-heading font-bold mb-4">Return Costs</h2>
            <p className="text-softgrey leading-relaxed">Customer pays unless faulty.</p>
          </section>

          <section className="bg-cream p-8 rounded-xl" data-testid="faulty-items-section">
            <div className="flex items-center gap-3 mb-4">
              <Wrench className="w-6 h-6 text-coral" />
              <h2 className="text-2xl font-heading font-bold">Faulty Items</h2>
            </div>
            <ul className="list-disc list-inside space-y-2 text-softgrey ml-2">
              <li><strong>30-day full refund right</strong></li>
              <li>Repair/replacement after</li>
            </ul>
          </section>

          <section data-testid="non-returnable-section">
            <div className="flex items-center gap-3 mb-4">
              <XCircle className="w-6 h-6 text-coral" />
              <h2 className="text-2xl font-heading font-bold">Non-Returnable</h2>
            </div>
            <ul className="list-disc list-inside space-y-2 text-softgrey ml-2">
              <li>Custom items</li>
              <li>Final sale items</li>
            </ul>
          </section>
        </div>

        <div className="mt-16 border-t border-border pt-8">
          <p className="text-softgrey text-sm">Need to request a return? <Link to="/contact" className="text-coral hover:underline font-semibold">Contact Us</Link> with your order number and reason.</p>
        </div>
      </div>
    </div>
  );
};
